import { ApiDescription, RequestsMethod, ApiData } from '@shared/clientTypes';

export const health: ApiDescription = {
  endpoint: '/health',
  method: RequestsMethod.Get,
};

export type Health = ApiData<null, { ok: boolean }>;
